<template>
  <div class="modal" @click.self="close">
    <div class="modal-content" :style="{ 'max-height': modalContentMaxHeight }">
      <button class="close-button" @click="close">&times;</button>

      <div class="modal-body">
        <div class="links-container">
          <a
            v-if="isAndroid"
            class="playstore-button"
            href="https://play.google.com/store/apps/details?id=com.chessmindai.chessmindaiapp&pcampaignid=web_share"
          >
          <font-awesome-icon :icon="['fab', 'android']" size="xl" /> Get on Google Play
          </a>
          <a
            v-else
            class="playstore-button"
            href="https://apps.apple.com/id/app/chessmind-ai/id6739585822"
          >
          <font-awesome-icon :icon="['fab', 'apple']" size="xl" /> Get on Apple Store
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppModal",
  data() {
    return {
      modalContentMaxHeight: `${window.innerHeight}px`,
      isAndroid: navigator.userAgent.match(/Android/i),
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  emits: ["close"],
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1000;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  backdrop-filter: blur(4px);
}

.modal-content {
  background-color: var(--base-color);
  display: flex;
  z-index: 1001;
  border: 1px solid var(--muted-color);
  border-radius: 0px;
  width: 100vw;
  position: absolute;
  bottom: 0px;
  left: 0px;
  flex-direction: column;
  padding-bottom: 20%;
}

.modal-header h4 {
  margin: 0;
}

.modal-title {
  color:white
}

.modal-body {
  padding: 2px 16px;
  justify-content: center;
  align-items: center;
}

.modal-footer {
  background-color: var(--muted-color);
  color: var(--base-color)
}

.small-link {
  font-size: 12px;
  color: var(--muted-color);
  font-weight: bold;
}

.playstore-link {
  display: inline-block;
  margin-top: 10px;
  padding: 10px 20px;
  background-color: var(--info-color);
  color: var(--base-color);
  text-decoration: none;
  text-align: center;
}

.playstore-button {
  display: inline-block;
  margin-top: 20px;
  padding: 12px 24px;
  background-color: var(--primary-color);
  color: var(--base-color);
  text-decoration: none;
  text-align: center;
  border-radius: 20px;
  font-weight: bold;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}

.playstore-button:hover {
  background-color: var(--primary-color);
}

.links-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.url {
  font-size: 12px;
  color: var(--contrast-base-color);
  font-weight: bold;
}

@media screen and (max-width: 760px) {
  .modal-content {
    width: 100vw;
  }
}

.close-button {
  position: absolute;
  top: -40px;
  right: -40px;
  background: transparent;
  border: none;
  font-size: 40px;
  color: var(--muted-color);
  cursor: pointer;
  z-index: 1002;
}

.close-button:hover {
  color: var(--contrast-base-color);
}
</style>
